import { render, staticRenderFns } from "./leftfive.vue?vue&type=template&id=bcb5a606&scoped=true&"
import script from "./leftfive.vue?vue&type=script&lang=js&"
export * from "./leftfive.vue?vue&type=script&lang=js&"
import style0 from "./leftfive.vue?vue&type=style&index=0&id=bcb5a606&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb5a606",
  null
  
)

export default component.exports